import { NoticeRep } from "@/api/home";
import { SlotType } from "@/api/slots";
import { DepositsLatestRep, UserVipInfo, Wallet } from "@/api/user";
import { create } from "zustand";
interface SuspensionType {
    able: boolean;
}
export interface PollingState {
    /**
     * 免费领取活动信息
     */
    activity_give: SlotType | null;
    /**
     * 用户VIP信息
     */
    user_vip_info: UserVipInfo | null;
    /**
     * 红包信息
     */
    red_packets?: { [key: string]: any };

    /**
     * 系统公告信息
     */
    system_notice?: { data: NoticeRep[]; summery: { unread: number; promotion_count: number } };
    /**
     * 系统停服信息
     */
    system_suspension?: SuspensionType;
    /**
     * 钱包信息
     */
    user_info?: Wallet;
    /**
     * 用户最近充值信息
     */
    user_latest_deposit?: DepositsLatestRep;
    /**
     * 站内信消息
     */
    user_letter?: { data: NoticeRep[]; summery: { unread: number } };

    /**
     * 轮询刷新事件
     */
    refresh: () => void;
    /**
     * 轮询取消事件
     */
    cancel: () => void;
}

interface Actions {
    setPollingState: (partialState: Partial<PollingState>) => void;
    // // setActivity: (values: PollingState["activity_give"]) => void;
    // reset: () => void;

    setPollingRefresh: (func: () => void) => void;
    setPollingCancel: (func: () => void) => void;
}

const initialState: Partial<PollingState> = {
    refresh: () => {},
    cancel: () => {},
};

// export const usePollingStore = create<PollingState & Actions>()(
//     immer((set) => ({
//         ...initialState,
//         setPollingState: (values) => {
//             //  todo 数据无变化则不更新。
//             set((state) => ({ ...state, ...values }));
//         },
//     }))
// );

export const usePollingStore = create<Partial<PollingState> & Actions>((set, getState) => {
    return {
        ...initialState,
        setPollingState: (values) => {
            // const preValue = JSON.stringify(values);
            // const oldValue = JSON.stringify(getState());
            //  todo 数据无变化则不更新。
            set((state) => ({ ...state, ...values }));
        },
        setPollingRefresh: (func: PollingState["refresh"]) =>
            set((state) => ({ ...state, refresh: func })),
        setPollingCancel: (func: PollingState["cancel"]) =>
            set((state) => ({ ...state, cancel: func })),
    };
});
